import React, { useEffect, useState } from 'react';
import { CkThemeProvider, PromoNotice } from '@NP-Webber/crm-kit/dist/next/index.js';
import useNextDesign from './useNextDesign';
import { markTourPending } from './NextDesignTour';

/**
 * Push-style card (bottom-right) that invites users who went back to the old design to switch again.
 * "לא עכשיו" hides it for a week, ✕ for a day; switching starts the guided tour of the new layout.
 */
const KEY = (uid) => `bchinot-next-promo:${uid || 'anon'}`;
const DAY = 864e5;

function snoozedUntil(uid) {
  try { return Number(localStorage.getItem(KEY(uid))) || 0; } catch { return 0; }
}
function snooze(uid, ms) {
  try { localStorage.setItem(KEY(uid), String(Date.now() + ms)); } catch { /* storage blocked */ }
}

export default function NextDesignPromo({ force = false } = {}) {
  const nextDesign = useNextDesign();
  const uid = nextDesign.userKey;
  const eligible = force || !nextDesign.enabled;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!eligible || (!force && snoozedUntil(uid) > Date.now())) { setOpen(false); return undefined; }
    const t = setTimeout(() => setOpen(true), force ? 300 : 3500);
    return () => clearTimeout(t);
  }, [eligible, uid, force]);

  if (!eligible) return null;
  return (
    // eslint-disable-next-line react/style-prop-object -- CkThemeProvider's `style` is the design style name
    <CkThemeProvider style="modern" mode="light" className="bchinot-next-globals">
      <PromoNotice
        open={open}
        icon="sparkle"
        badge="חדש"
        title="עיצוב חדש מחכה לך"
        placement="bottom-right"
        onClose={() => { snooze(uid, DAY); setOpen(false); }}
        primary={{
          label: 'מעבר לעיצוב החדש',
          icon: 'sparkle',
          onClick: () => { markTourPending(uid); setOpen(false); nextDesign.setEnabled(true); },
        }}
        secondary={{ label: 'לא עכשיו', onClick: () => { snooze(uid, 7 * DAY); setOpen(false); } }}
      >
        מסכים נקיים יותר, טבלאות חכמות, חיפוש מהיר (Ctrl+K), מצב כהה ובחירת סגנון.
        {' '}אפשר לחזור לעיצוב הקודם בכל רגע מהתפריט האישי.
      </PromoNotice>
    </CkThemeProvider>
  );
}
